import { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const StickyCards = ({ cards }) => {
  const container = useRef(null);
  const imageRefs = useRef([]);

  useGSAP(
    () => {
      gsap.registerPlugin(ScrollTrigger);

      const imageElements = imageRefs.current;
      const totalCards = imageElements.length;

      if (!imageElements[0]) return;

      // Set initial positions
      gsap.set(imageElements[0], { y: '0%', scale: 1, rotation: 0 });

      for (let i = 1; i < totalCards; i++) {
        if (!imageElements[i]) continue;
        gsap.set(imageElements[i], { y: '100%', scale: 1, rotation: 0 });
      }

      // Create scroll timeline
      const scrollTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: '.sticky-cards',
          start: 'top top',
          end: `+=${window.innerHeight * (totalCards + 1)}`,
          pin: true,
          scrub: 0.5,
          pinSpacing: true,
        },
      });

      for (let i = 0; i < totalCards - 1; i++) {
        const currentImage = imageElements[i];
        const nextImage = imageElements[i + 1];
        const position = i;
        if (!currentImage || !nextImage) continue;

        scrollTimeline.to(
          currentImage,
          {
            scale: 0.7,
            rotation: 5,
            duration: 1,
            ease: 'none',
          },
          position,
        );

        scrollTimeline.to(
          nextImage,
          {
            y: '0%',
            duration: 1,
            ease: 'none',
          },
          position,
        );
      }

      // Handle resize
      const resizeObserver = new ResizeObserver(() => {
        ScrollTrigger.refresh();
      });

      if (container.current) {
        resizeObserver.observe(container.current);
      }

      // Cleanup
      return () => {
        resizeObserver.disconnect();
        scrollTimeline.kill();
        ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      };
    },
    { scope: container },
  );

  return (
    <>
      <div className="relative h-screen w-full bg-white" ref={container}>
        <div className="sticky-cards relative flex h-full w-full items-center justify-center overflow-hidden px-2.5">
          <div className="relative h-full w-full overflow-hidden rounded-3xl">
            {cards.map((card, i) => (
              <img
                key={card.id}
                src={card.image}
                alt={card.alt || `Card ${i + 1}`}
                className="absolute inset-0 h-full w-full object-cover rounded-3xl"
                ref={(el) => {
                  imageRefs.current[i] = el;
                }}
              />
            ))}
          </div>
        </div>
      </div>
      {/* Empty white spacer section */}
      <div className="h-screen w-full bg-white"></div>
    </>
  );
};

export default StickyCards;
